import React, { Component } from "react";
import "../Ventas/ventas.css";
import "./usuarios.css";
import Navbar from "../../componentes/navbar/navbar";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import { toast } from "react-toastify";
import ModalMessage from "../../componentes/modal/ModalMessages/ModalMessages";
import UsuarioModal from "../../componentes/modal/UsuarioModal";
import ChangePasswordModal from "../../componentes/modal/ChangePasswordModal";
import {
    agregarusuario,
    cambiarContrasenaUsuario,
    editarUsuario,
    getlistaTiposUser,
    getListaUsuarios,
    resetContrasenaUsuario,
} from "../../service/api";

export default class UsuariosPage extends Component {
    state = {
        loading: false,
        usuarios: [],
        q: "",
        estatus: "all", // all | 1 | 2
        sortKey: "nombre",
        sortDir: "asc",
        // modales
        showUsuarioModal: false,
        usuarioMode: "create", // create | edit
        usuarioSeleccionado: null,
        verMensaje: false,
        modalMessage: "",
        modalEmailReal: "", 
        accion: "",
        array_tipousuarios:[],
        selectedRowId: null,
    };

    componentDidMount() {
        const datos = localStorage.getItem("datosm");
        if (!datos || datos === "") {
            window.location.href = "/";
            return;
        }
        this.getTiposUser()
        this.fetchUsuarios();
   
    }
    getTiposUser = async () => {
        var resp = await getlistaTiposUser();
        if (resp && resp.code === 0) {
            const array_tipousuarios = resp.data || [];
            this.setState({ array_tipousuarios });
        }
    }

    // ===== Helpers =====
    estatusLabel = (idestatus) => (Number(idestatus) === 1 ? "Activo" : "Inactivo");

    tipoUsuarioLabel = (idtipousuario) => {
        const map = { 1: "Administrador", 2: "Usuario" };
        return map[Number(idtipousuario)] || String(idtipousuario || "-");
    };

    formatDate = (iso) => {
        if (!iso) return "-";
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return "-";

        const day = d.getDate();
        const months = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
        const mon = months[d.getMonth()];
        const year = d.getFullYear();

        return `${day}/${mon}/${year}`;
    };

    maskEmail = (email) => {
        const s = String(email || "").trim();
        if (!s.includes("@")) return s;

        const [user, domain] = s.split("@");
        const first3 = user.slice(0, 3);
        const safeFirst3 = first3 || user;

        return `${safeFirst3}****@${domain}`;
    };

    normalizeUser = (u) => {
        const idusuario = u?.idusuario ?? null;
        return {
            idusuario,
            email: u?.email ?? "",
            nombre: u?.nombre ?? "",
            idtipousuario: u?.idtipousuario ?? 1,
            tipo: u?.tipo ?? "",
            idestatus: u?.idestatus ?? 1,
            estatusTxt: this.estatusLabel(u?.idestatus),
            creado: u?.creado ?? "",
            actualizado: u?.actualizado ?? "",
            _key: String(idusuario ?? Math.random()),
            _rowId: String(idusuario ?? Math.random()),
        };
    };

    // ===== API =====
    fetchUsuarios = async () => {
        this.setState({ loading: true });

        try {
            const resp = await getListaUsuarios();

            if (resp?.code === 0) {
                const raw = resp?.data || [];
                const arr = Array.isArray(raw) ? raw : raw?.data || [];
                const usuarios = (arr || []).map(this.normalizeUser);

                this.setState({ usuarios, loading: false, selectedRowId: null });
                return;
            }

            toast.info(resp?.message || "No se pudieron obtener los usuarios.");
            this.setState({ usuarios: [], loading: false, selectedRowId: null });
        } catch (e) {
            toast.info("Error al obtener usuarios.");
            this.setState({ usuarios: [], loading: false, selectedRowId: null });
        }
    };

    // ===== Filters =====
    onChangeSearch = (e) => this.setState({ q: e.target.value || "", selectedRowId: null });

    onChangeEstatus = (e) => this.setState({ estatus: e.target.value, selectedRowId: null });

    getFiltered = () => {
        const { usuarios, q, estatus } = this.state;
        const qq = String(q || "").trim().toLowerCase();

        let list = [...(usuarios || [])];

        if (estatus !== "all") {
            const st = Number(estatus);
            list = list.filter((u) => Number(u.idestatus) === st);
        }

        if (qq) {
            list = list.filter((u) => {
                const email = String(u.email || "").toLowerCase();
                const nombre = String(u.nombre || "").toLowerCase();
                const tipo = String(u.tipo || "").toLowerCase();
                return email.includes(qq) || nombre.includes(qq) || tipo.includes(qq);
            });
        }

        return list;
    };

    // ===== Ordenamiento (como Ventas) =====
    compareValues = (a, b) => {
        if (a == null) a = "";
        if (b == null) b = "";

        const na = Number(a);
        const nb = Number(b);

        const bothNumeric =
            !Number.isNaN(na) &&
            !Number.isNaN(nb) &&
            String(a).trim() !== "" &&
            String(b).trim() !== "";

        if (bothNumeric) return na - nb;

        return String(a).localeCompare(String(b), "es", { numeric: true, sensitivity: "base" });
    };

    getSortValue = (u, key) => {
        switch (key) {
            case "nombre":
                return u.nombre;
            case "email":
                return u.email;
            case "tipo":
                return u.tipo;
            case "estatus":
                return u.estatusTxt;
            case "creado":
                return u.creado;
            case "actualizado":
                return u.actualizado;
            default:
                return "";
        }
    };

    onSort = (key) => {
        this.setState((prev) => {
            const same = prev.sortKey === key;
            const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
            return { sortKey: key, sortDir: nextDir };
        });
    };

    getSortedItems = () => {
        const { sortKey, sortDir } = this.state;
        const filtered = this.getFiltered();

        return [...filtered].sort((ua, ub) => {
            const a = this.getSortValue(ua, sortKey);
            const b = this.getSortValue(ub, sortKey);
            const cmp = this.compareValues(a, b);
            return sortDir === "asc" ? cmp : -cmp;
        });
    };

    // ===== Selección toggle =====
    onSelectRow = (rowId) => {
        this.setState((prev) => ({
            selectedRowId: prev.selectedRowId === rowId ? null : rowId,
        }));
    };

    // ===== Modales: Usuario =====
    openCreate = () => {
        this.setState({
            showUsuarioModal: true,
            usuarioMode: "create",
            usuarioSeleccionado: null,
            selectedRowId: null,
        });
    };

    openEdit = (u) => {
        this.setState({
            showUsuarioModal: true,
            usuarioMode: "edit",
            usuarioSeleccionado: u,
            selectedRowId: u?._rowId ?? null,
        });
    };

    closeUsuarioModal = () => {
        this.setState({
            showUsuarioModal: false,
            usuarioMode: "create",
            usuarioSeleccionado: null,
        });
    };

    onSaveUsuario = async (payload) => {
        this.setState({ loading: true, showUsuarioModal: false });

        try {
            const { usuarioMode, usuarioSeleccionado } = this.state;

       //   // consolelog(usuarioSeleccionado.idusuario + " - Payload usuario:", payload);
            const r =
                usuarioMode === "edit"
                    ? await editarUsuario(usuarioSeleccionado.idusuario, payload)
                    : await agregarusuario(payload);

            if (r?.code === 0) {
                toast.success(r.message || "Usuario guardado.");
                this.fetchUsuarios();
            } else {
                this.setState({ loading: false });
                toast.info(`${r?.code} - ${r?.message}`);
            }
        } catch (e) {
            this.setState({ loading: false });
            toast.info("Error al guardar usuario.");
        }
    };



    // ===== Reset password (confirmación) =====
    solicitarReset = (u) => {
        const email = u?.email || "";
      
        this.setState({
          verMensaje: true,
          accion: "reset",
          modalMessage: this.maskEmail(email),
          modalEmailReal: email,
          userPassTarget: u,
          selectedRowId: u?._rowId ?? null,
        });
      };
    

    completaReset = async (bandera) => {
        if (bandera !== 1) {
          this.setState({
            verMensaje: false,
            accion: "",
            modalMessage: "",
            modalEmailReal: "",
            userPassTarget: null,
          });
          return;
        }
      
        const email = this.state.modalEmailReal; //  REAL
        if (!email) {
          this.setState({ verMensaje: false });
          toast.info("No se encontró el email.");
          return;
        }
      
        this.setState({ loading: true, verMensaje: false });
      
        try {
          const r = await resetContrasenaUsuario({ email });
      
          if (r?.code === 0) {
            toast.success(r.message || "Se enviaron instrucciones para restablecer.");
            this.setState({ loading: false, modalEmailReal: "", modalMessage: "" });
          } else {
            this.setState({ loading: false });
            toast.info(`${r?.code} - ${r?.message}`);
          }
        } catch (e) {
          this.setState({ loading: false });
          toast.info("Error al restablecer contraseña.");
        }
      };
      

    render() {
        const {
            loading,
            q,
            estatus,
            showUsuarioModal,
            usuarioMode,
            usuarioSeleccionado,
            selectedRowId,
            array_tipousuarios
        } = this.state;

        const items = this.getSortedItems();

        return (
            <div className="v-page">
                <Navbar />

                {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

                <UsuarioModal
                    show={showUsuarioModal}
                    mode={usuarioMode}
                    roles={array_tipousuarios}
                    usuario={usuarioSeleccionado}
                    loading={loading}
                    onClose={this.closeUsuarioModal}
                    onSave={this.onSaveUsuario}
                />



                {this.state.verMensaje ? (
                    <ModalMessage
                        show={this.state.verMensaje}
                        titulo={"Restablecer contraseña"}
                        bandera={"cambiarContrasena"}
                        mensaje={this.state.modalMessage}
                        cerrarBorrar={this.completaReset}
                    />
                ) : null}

                <div className="u-shell">
                    {/* Header (igual estilo que ventas/afiliaciones) */}
                    <div className="v-top v-top--users">
                        <h1 className="v-title">Usuarios</h1>

                        <div className="u-actionsLike">
                            <div className="u-filterLike">
                                <select value={estatus} onChange={this.onChangeEstatus}>
                                    <option value="all">Todos</option>
                                    <option value="1">Activos</option>
                                    <option value="2">Inactivos</option>
                                </select>
                            </div>

                            <button className="v-btn" onClick={this.fetchUsuarios} disabled={loading}>
                                ACTUALIZAR
                            </button>

                            <button className="v-btn" onClick={this.openCreate} disabled={loading}>
                                AGREGAR USUARIO
                            </button>
                        </div>
                    </div>



                    {/* Tabla (reusa v-card / v-table) */}
                    <div className="vard">
                        <div className="v-card">
                            <div className="v-tableWrap">
                                <table className="v-table">
                                    <thead>
                                        <tr>

                                            <th className="v-thSort" onClick={() => this.onSort("nombre")}>Nombre</th>
                                            <th className="v-thSort" onClick={() => this.onSort("email")}>Email</th>
                                            <th className="v-thSort" onClick={() => this.onSort("tipo")}>Tipo</th>
                                            <th className="v-thSort" onClick={() => this.onSort("estatus")}>Estatus</th>
                                            <th className="v-thSort" onClick={() => this.onSort("creado")}>Creado</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" className="v-empty">
                                                    No hay registros disponibles
                                                </td>
                                            </tr>
                                        ) : (
                                            items.map((u, idx) => {
                                                const isActive = selectedRowId === u._rowId;

                                                return (
                                                    <tr
                                                        key={`${u._key}-${idx}`} className={isActive ? "row-active" : ""}
                                                        onClick={() => this.onSelectRow(u._rowId)} style={{ cursor: "pointer" }} >

                                                        <td className="v-mono">{u.nombre}</td>
                                                        <td className="v-mono" >{this.maskEmail(u.email)}</td>
                                                        <td className="v-mono">{u.tipo}</td>

                                                        <td>
                                                            <span className={`v-badge ${Number(u.idestatus) === 1 ? "ok" : "warn"}`}>
                                                                {u.estatusTxt}
                                                            </span>
                                                        </td>

                                                        <td className="v-mono">{this.formatDate(u.creado)}</td>

                                                        <td onClick={(e) => e.stopPropagation()}>
                                                            <button
                                                                className="a-linkBtn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.openEdit(u);
                                                                }}
                                                                disabled={loading}
                                                            >
                                                                Editar
                                                            </button>

                                                

                                                            <button
                                                                className="a-linkBtn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.solicitarReset(u);
                                                                }}
                                                                disabled={loading}
                                                                title="Restablecer contraseña por email"
                                                                style={{ marginLeft: 8 }}
                                                            >
                                                                Restablecer
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
